import ExpandToggle from "@threespot/expand-toggle";

class AccordionList {
  constructor(el) {
    this.el = el;
    this.toggles = this.el.querySelectorAll('[data-expands]');

    this.toggles.forEach(el => {
      new ExpandToggle(el);
    });
  }
}


let accordions = document.querySelectorAll('[data-controller="accordion-list"]');


accordions.forEach((accordion) => {
  new AccordionList(accordion);
});